<template>
  <div class="bg-dark py-5 rounded-3">
    <div class="row col-11 mx-auto flex-row">
      <div
        class="col-12 col-md-3 position-relative d-flex flex-row justify-content-center"
      >
        <img
          src="@/assets/img/ventus-phone-nobg.png"
          class="position-absolute ms-10 d-none d-lg-block"
          style="bottom: -48px"
          width="240"
          alt=""
        />
      </div>
      <div class="col-12 col-lg-9">
        <div class="col-md-9 mx-auto text-center">
          <h3 class="text-white">¿Necesitas ayuda?</h3>
          <p class="text-sm">
            ¡Estamos aquí para ayudarte! Escríbenos por WhatsApp para recibir
            atención<br />personalizada, o bien, agendar una llamada para
            asesorarte y resolver cualquier duda.
          </p>
          <a href="https://api.whatsapp.com/send/?phone=%2B528715060593&text&type=phone_number&app_absent=0" target="_blank" class="btn btn-warning rounded-pill btn-sm fw-light">
            Contactar a un asesor
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
